/* template */
<template><div class="mpx-root-view"><ts-collapse :externClass='("seat-information-group "+(hasRightsChoosed && "no-padding")+" "+(isTransfer && "transfer"))' :expand="(!hasRightsChoosed)"><seat-information v-for="(item, index) in (selectSeatInfo)" :class='((selectSeatInfo.length > 1 && "seat-information")+" ")' :selectSeatInfo="(item)" :isPreScramble="(isPreScramble)" :isStudent="(isStudent)" :ticketData="(ticketData[index])" :seatInfoIndex="(index)" @show="openPriceEstimation"/></ts-collapse><div class="student-notice" v-if="(isStudent)"><div class="student-seat-notice"><mpx-image src="https://ut-static.udache.com/webx/sfc/j9QJ2xhfiMsq3IjQ5Bdf9.png" class="student-seat-icon"/><div>温馨提示：硬座/硬卧/二等座/无座席别可享学生优惠价格最终以实际占座成功的票价为准。</div></div></div><price-detail-info-alter :show="(showPriceEstimation)" :title="(priceEstimation.title)" :priceDetail="(priceEstimation.detail)" priceDetailCardTip="卧铺价格仅供参考，以实际出票结果收取费用" @close="closePriceEstimation"/></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m0ff1ee9f"}'>
  .student-notice
    font-size 12px
    font-weight 400
    color #999999
    margin 12px 6px 12px 12px
    display flex
    justify-content space-between
    .student-seat-notice
      display flex
      .student-seat-icon
        width 15px
        height 11px
        position relative;
        top 2px;
        margin-right 4px;
  .seat-information-group
    background linear-gradient(180deg, #FFFFFF 69%, rgba(255, 255, 255, 0) 100%)
    margin 0 -12px
    padding 10px
    padding-bottom 0
    &.transfer
      background #fff
      margin 0
      border-radius 8px
      padding 14px 13px
    &.no-padding
      padding-top 0
    .seat-information
      &:not(:last-child)
        margin-bottom 10px
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m0ff1ee9f"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./seat-information-group.mpx.js?isComponent&outputPath=components%2Fseat-information-group0ff1ee9f%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./seat-information-group.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fseat-information-group0ff1ee9f%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m0ff1ee9f"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/seat-information-group0ff1ee9f/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'price-detail-info-alter':getComponent(require("../price-detail-info-alter/index.mpx?isComponent&outputPath=components%2Findex853d8b3a%2Findex")),'seat-information':getComponent(require("../../pages/train-detail/components/seat-information/index.mpx?isComponent&outputPath=components%2Findex17fa8b3c%2Findex")),'ts-collapse':getComponent(require("../../../node_modules/@didi/spring-ui/ts-collapse/index.mpx?isComponent&outputPath=components%2Findex3239cc50%2Findex")),'mpx-image':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-image.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
